import axios from '@/services/apiAxios'
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        activeAccounts: [],
    },
    mutations: {
        setActiveAccounts(state, payload) {
            console.log('insert store');
            state.activeAccounts = state.activeAccounts.concat(payload);
        }
    }, 
    actions: {
        fetchActiveAccounts({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.accounting.routePrefix}/account-actives?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setActiveAccounts', response.data);
                    resolve(response);
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                }
                );
            })
        },
        fetchActiveAccount({ commit, rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.accounting.routePrefix}/accounts/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setActiveAccounts', response.data);
                    resolve(response);
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                } 
                );
            })
        },
        setActiveAccounts({commit}, data) {
            commit('setActiveAccounts', data);
        }

    }
}